import { Grid } from '@mui/material';
import React from 'react';

import { SolutionActionFormProps } from './SolutionActionForm.props';
import { Typography, TypographyFontWeightProps, TypographyVariantProps } from '../../atoms/Typography';
import { SolutionActionMenu } from '../../molecules/SolutionActionMenu';

export const SolutionActionForm: React.FC<SolutionActionFormProps> = ({
  options,
  value,
  onChange,
  isError
}) => {
  return (
    <Grid container spacing={1} marginTop={1} marginBottom={1}>
      <Grid size={{ xs: 12 }}>
        <Typography
          variant={TypographyVariantProps.Body2}
          fontWeight={TypographyFontWeightProps.Bold}
        >
          Solution Action
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <SolutionActionMenu
          options={options}
          value={value}
          onChange={onChange}
          error={isError}
        />
      </Grid>
    </Grid>
  );
};